<!-- <h4>Thanks for replying. Your response is noted.</h4> -->
<div class="thanks_block p-4">
  <img src="../../../../assets/img/tick-ok.svg" />
  <p class="text-center p-4">
    Thanks for replying.<br />
    Your response is noted.
  </p>
</div>
